<template lang="pug">
.algolia-results
  .container
    .row(
      :key="query"
      v-if="query && hasResults"
    )
      .col-lg-3.col-md-6(
        v-if="queries.pagesAndArticles && queries.pagesAndArticles.hits.length"
      )
        div.algolia-results__title.meta-label(v-html="queries.pagesAndArticles.$q.label")
        search-feed(
          :hits="queries.pagesAndArticles.hits"
          :query="query"
          name="pagesAndArticles"
        )
      
      .col-lg-3.col-md-6(
        v-if="queries.events && queries.events.hits.length"
      )
        
        div.algolia-results__title.meta-label(v-html="queries.sw.$q.label")
        search-feed(
          :hits="queries.sw.hits"
          :query="query"
          name="sw"
        )
        
        div.algolia-results__title.meta-label(v-html="queries.events.$q.label")
        search-feed(
          :hits="queries.events.hits"
          :query="query"
          name="events"
        )

      .col-lg-3.col-md-6(
        v-if="(queries.staffingToday && queries.staffingToday.hits.length) || (queries.techCompanies && queries.techCompanies.hits.length)"
      )
        template(
          v-if="(queries.techCompanies && queries.techCompanies.hits.length)"
        )
          div.algolia-results__title.meta-label(v-html="queries.techCompanies.$q.label")
          search-feed(
            :hits="queries.techCompanies.hits"
            :query="query"
            name="techCompanies"
          )
        template(
          v-if="(queries.staffingToday && queries.staffingToday.hits.length)"
        )
          div.algolia-results__title.meta-label(v-html="queries.staffingToday.$q.label")
          search-feed(
            :hits="queries.staffingToday.hits"
            :query="query"
            name="staffingToday"
          )

      .col-lg-3.col-md-6(
        v-if="(queries.suppliers && queries.suppliers.hits.length) || (queries.marketplace && queries.marketplace.hits.length)"
      )
        template(
          v-if="(queries.suppliers && queries.suppliers.hits.length)"
        )
          div.algolia-results__title.meta-label(v-html="queries.suppliers.$q.label")
          search-feed(
            :hits="queries.suppliers.hits"
            :query="query"
            name="suppliers"
          )

        template(
          v-if="(queries.marketplace && queries.marketplace.hits.length)"
        )
          div.algolia-results__title.meta-label(v-html="queries.marketplace.$q.label")
          search-feed(
            :hits="queries.marketplace.hits"
            :query="query"
            name="marketplace"
          )

    .algolia-results__no-results(
      v-if="!hasResults && query"
    )
      p No results found

</template>

<script>
const $ = jQuery;
export default {
  
  name: "algolia-search",

  components: {
    'search-feed' : () => import('./search-feed')
  },

  props: {
    input: {
      type: HTMLElement,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },

  data(){
    const response = null;
    const hits = [];
    const total = 0;
    const $q = null;
    return {
      query: '',
      empty: true,
      queries: {
        pagesAndArticles: {
          hits, response, total, $q
        },
        events: {
          hits, response, total, $q
        },
        sw: {
          hits, response, total, $q
        },
        staffingToday: {
          hits, response, total, $q
        },
        techCompanies: {
          hits, response, total, $q
        },
        suppliers: {
          hits, response, total, $q
        },
        marketplace: {
          hits, response, total, $q
        }
      }
    }
  },

  computed: {
    hasResults(){
      return Object.values(this.queries).filter( q => q && q.hits && q.hits.length ).length > 0;
    }
  },

  created(){
    Promise.all([
      import('../helpers/search'),
      import('algoliasearch')
    ]).then(([search, AlgoliaSearch]) => {

      this.client = new AlgoliaSearch(
        this.config.application_id,
        this.config.search_api_key
      );
      const client = this.searchWrapper = new search.SearchWrapper( this.client );

      this.queries.pagesAndArticles.$q = search.queries.pagesAndArticles({client});
      this.queries.pagesAndArticles.$q.target = this.queries.pagesAndArticles;

      this.queries.events.$q = search.queries.events({
        client,
        request: {
          params: {
            hitsPerPage : 3
          }
        }
      });
      this.queries.events.$q.target = this.queries.events;

      this.queries.sw.$q = search.queries.sw({
        client,
        request: {
          params: {
            hitsPerPage: 2
          }
        }
      });
      this.queries.sw.$q.target = this.queries.sw;

      this.queries.techCompanies.$q = search.queries.techCompanies({
        client,
        request: {
          params: {
            hitsPerPage: 2
          }
        }
      });
      this.queries.techCompanies.$q.target = this.queries.techCompanies;

      this.queries.staffingToday.$q = search.queries.staffingToday({
        client,
        request: {
          params: {
            hitsPerPage: 2
          }
        }
      });
      this.queries.staffingToday.$q.target = this.queries.staffingToday;

      this.queries.suppliers.$q = search.queries.suppliers({
        client,
        request:{
          params: {
            hitsPerPage: 2
          }
        }
      });
      this.queries.suppliers.$q.target = this.queries.suppliers;

      this.queries.marketplace.$q = search.queries.marketplace({
        client,
        request:{
          params: {
            hitsPerPage: 2
          }
        }
      });
      this.queries.marketplace.$q.target = this.queries.marketplace;
    });
  },

  mounted(){
    $(this.input).attr({
      autocomplete: 'off',
      autocorrect: 'off',
      autocapitalize: 'off'
    });
    $(this.input)
      .on('input.algolia-search', e => this.onInput(e) )
      .on('focus.algolia-search', e => this.onFocus(e) );

    $(this.input).closest('form')
      .on('submit', e => e.preventDefault() )
      .find( 'button[type="submit"]' ).hide();

    this.$clear = $(this.input).closest('form').find('button[data-action="clear"]');
    this.$clear.on('click', () => $(this.input).val('').trigger('input') );
  },

  beforeDestroy(){
    $(this.input).off('.algolia-search');
  },

  watch: {
    empty(v){
      this.$clear.toggleClass('shown', !v);
      $(this.input).trigger( v ? 'empty' : 'notempty' );
    }
  },

  methods: {
    onFocus(e){
      if( this.input.value ){
        this.$emit('focus');
      }
    },
    onInput(e){
      this.query = this.input.value;
      const query = this.query.toLowerCase();
      this.$emit('input', query);
      if( !this.query ){
        if( !this.empty ) this.empty = true;
        Object.values(this.queries).forEach( q => q.hits = [] );
        return;
      }
      else {
        if( this.empty ) this.empty = false;
      }
      clearTimeout( this.inputTimeout );
      this.inputTimeout = setTimeout( () => this.search(), 200 );
    },

    search(){
      const query = this.query;
      if( window && window.dataLayer ){
        window.dataLayer.push({
          event         : 'gaEvent',
          eventCategory : 'Search',
          eventAction   : 'Results',
          eventLabel    : this.query
        });
      }
      Object.values( this.queries ).forEach( q => { 
        q.$q.search(query);
      });
    }
  }

}
</script>

<style lang="scss">

</style>